/* eslint-disable dot-notation */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */
/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-state */
/* eslint-disable jsx-a11y/label-has-associated-control */

// @mui material components
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import "react-dropdown/style.css";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import {
  Box,
  // TableContainer,
  Table,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  // Paper,
} from "@mui/material";
// import { useNavigate } from "react-router-dom";
// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import CargoLoader from "components/CargoLoader";
import FilterBar, { filterRows } from "components/FilterBar";
import Pagination, { usePagination } from "components/Pagination";
import ConfirmOrder from "./confirm_order";
import ExportData from "./export_order";
// import { useTranslation } from "react-i18next";
// import DeleteLab from "./delete_lab";

function AllOrders() {
  // const  rows: [1];
  // const { t } = useTranslation();
  // const navigate = useNavigate();
  const [customer, setCustomer] = useState("");
  const [loading, setloading] = useState(false);
  const [rows, setRows] = useState([0]);
  const [users, setUsers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [query, setQuery] = useState("");
  const [containers, setContainers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const getContainers = async () => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/containers");
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setContainers(data["containers"]);
  };
  const getCustomers = async () => {
    // const token = sessionStorage.getItem("token");
    // const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/customers");
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setCustomers(data["customers"]);
  };
  const getUsersCustomers = async () => {
    // const token = sessionStorage.getItem("token");
    const headers = { ContentType: `application/json` };
    const response = await fetch("https://trust-cargo.co/anas_backend/api/customers", { headers });
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setUsers(data["customers"]);
    setCustomer(data["customers"][0]["code"]);
  };

  const [shopnumber1, setShopNumber1] = useState("");
  const [shopnumber2, setShopNumber2] = useState("");
  const [phone, setPhone] = useState("");

  const [order_number, setOrderNumber] = useState("");
  const [deliverydate, setDeliveryDate] = useState("");

  // contants of my array
  const [orderid, setOrderID] = useState([""]);
  const [ordercode, setOrderCode] = useState([""]);
  const [container_id, setContainerID] = useState([""]);
  const [customer_id, setCustomerID] = useState([""]);
  const [itemarray, setItemArray] = useState([""]);
  const [statusProducts, setStatusProduct] = useState([""]);
  const [itemnumber, setItemNumber] = useState([""]);
  const [photo, setPhoto] = useState([""]);
  const [description1, setDescription1] = useState([""]);
  const [description2, setDescription2] = useState([""]);
  const [category, setCategory] = useState([""]);
  const [ctn, setCTN] = useState([]);
  const [qtytoctn, setQtyToCtn] = useState([""]);

  const [utoprice, setUtoPrice] = useState([""]);
  const [cbm, setCBM] = useState([""]);
  // const [amount, setAmount] = useState([""]);
  // eslint-disable-next-line arrow-body-style

  const ttocbm = cbm.map((e, index) => {
    return e * ctn[index];
  });

  // const total_cbm = ttocbm.reduce((e1, e2) => {
  //   return e1 + e2;
  // });
  // const total_ctn = ctn.reduce((e1, e2) => {
  //   return e1 + e2;
  // });

  const ttoqty = ctn.map((e, index) => {
    return e * qtytoctn[index];
  });
  const amount = utoprice.map((e, index) => {
    return e * ttoqty[index];
  });

  // const total_amount = amount.reduce((e1, e2) => {
  //   return e1 + e2;
  // });
  // const total_items = itemarray.reduce((e1, e2) => {
  //   return e1 + e2;
  // });

  // const [ttocbm, setTtoCBM] = useState([""]);
  const [nw, setNW] = useState([""]);
  // const [gw, setGW] = useState([""]);
  const [status, setStatus] = useState([""]);
  const [notes, setNotes] = useState([""]);
  const gw = nw.map((e, index) => {
    return e * ctn[index];
  });
  // const total_gw = gw.reduce((e1, e2) => {
  //   return e1 + e2;
  // });
  async function getOrderDetails() {
    const headers = { ContentType: `application/json` };
    const response = await fetch(`https://trust-cargo.co/anas_backend/api/order_details`, {
      headers,
    });
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setOrders(data["order_details"]);
    setloading(false);
  }

  const handleOrderCodeChange = (event, index) => {
    setOrderCode((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleProductStautsChange = (event, index) => {
    setStatusProduct((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleContainerIDChange = (event, index) => {
    setContainerID((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleCustomerIDChange = (event, index) => {
    setCustomerID((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };

  const handleItemChange = (event, index) => {
    setItemArray((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleItemNumberChange = (event, index) => {
    setItemNumber((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handlePhotoChange = (event, index) => {
    setPhoto((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleDescChange = (event, index) => {
    setDescription1((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleDesc2Change = (event, index) => {
    setDescription2((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleCategoryChange = (event, index) => {
    setCategory((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleCTNChange = (event, index) => {
    setCTN((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleQTYTOCTNChange = (event, index) => {
    setQtyToCtn((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  // const handleTTOQTYChange = (event, index) => {
  //   setTtoQty((state) =>
  //     state.map((el, index1) => {
  //       console.log("index1", index1);
  //       return index === index1 ? event.target.value : el;
  //     })
  //   );
  // };

  const handleUTOPriceChange = (event, index) => {
    setUtoPrice((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  // const handleAmountChange = (event, index) => {
  //   setAmount((state) =>
  //     state.map((el, index1) => {
  //       console.log("enver", event.target.value);
  //       return index === index1 ? event.target.value : el;
  //     })
  //   );
  // };
  const handleCBMChange = (event, index) => {
    setCBM((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  // const handleTTOCBMChange = (event, index) => {
  //   setTtoCBM((state) =>
  //     state.map((el, index1) => {
  //       console.log("index1", index1);
  //       return index === index1 ? event.target.value : el;
  //     })
  //   );
  // };
  const handleNWChange = (event, index) => {
    setNW((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  // const handleGWChange = (event, index) => {
  //   setGW((state) =>
  //     state.map((el, index1) => {
  //       console.log("index1", index1);
  //       return index === index1 ? event.target.value : el;
  //     })
  //   );
  // };
  const handleStatusChange = (event, index) => {
    setStatus((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const handleNotesChange = (event, index) => {
    setNotes((state) =>
      state.map((el, index1) => {
        console.log("index1", index1);
        return index === index1 ? event.target.value : el;
      })
    );
  };
  const total_ctn =
    ctn.length !== 0
      ? ctn.reduce((e1, e2) => {
          console.log("amount");
          console.log(amount);
          return Number(e1) + Number(e2);
        })
      : "0";
  const total_gw =
    gw.length !== 0
      ? gw.reduce((e1, e2) => {
          console.log("amount");
          console.log(amount);
          return Number(e1) + Number(e2);
        })
      : "0";
  const total_t_cbm =
    ttocbm.length !== 0
      ? ttocbm.reduce((e1, e2) => {
          console.log("amount");
          console.log(amount);
          return Number(e1) + Number(e2);
        })
      : "0";

  useEffect(() => {
    setloading(true);
    getOrderDetails();
    getUsersCustomers();
    getContainers();
    getCustomers();
  }, []);
  useEffect(() => {
    const orderid1 = [];
    orders.forEach((e) => {
      orderid1.push(e.order_id);
    });
    const ordercode1 = [];
    orders.forEach((e) => {
      ordercode1.push(e.order_code);
    });
    const container_id1 = [];
    orders.forEach((e) => {
      container_id1.push(e.container_id);
    });
    const customer_id1 = [];
    orders.forEach((e) => {
      customer_id1.push(e.customer_id);
    });
    const ite1 = [];
    orders.forEach((e) => {
      ite1.push(e.our_item);
    });
    const status1 = [];
    orders.forEach((e) => {
      status1.push(e.status);
    });
    const photo1 = [];
    orders.forEach((e) => {
      photo1.push(e.photo);
    });
    const cate = [];
    orders.forEach((e) => {
      cate.push(e.category);
    });
    const ctnorders = [];
    orders.forEach((e) => {
      ctnorders.push(e.ctn);
    });
    const qtytoctnorders = [];
    orders.forEach((e) => {
      qtytoctnorders.push(e.qty_ctn);
    });

    const desc1 = [];
    orders.forEach((e) => {
      desc1.push(e.description1);
    });
    const desc2 = [];
    orders.forEach((e) => {
      desc2.push(e.description2);
    });
    const utopriceorders = [];
    orders.forEach((e) => {
      utopriceorders.push(e.u_price);
    });
    const cbmorders = [];
    orders.forEach((e) => {
      cbmorders.push(e.cbm);
    });

    const nworders = [];
    orders.forEach((e) => {
      nworders.push(e.n_w);
    });

    const statusorders = [];
    orders.forEach((e) => {
      statusorders.push(e.status);
    });
    const notesorders = [];
    orders.forEach((e) => {
      notesorders.push(e.notes);
    });
    setOrderID(orderid1);
    setOrderCode(ordercode1);
    setContainerID(container_id1);
    setCustomerID(customer_id1);
    setItemArray(ite1);
    setStatusProduct(status1);
    setPhoto(photo1);
    setCategory(cate);
    setCTN(ctnorders);
    setQtyToCtn(qtytoctnorders);
    setDescription1(desc1);
    setDescription2(desc2);
    setUtoPrice(utopriceorders);
    setCBM(cbmorders);
    setNW(nworders);
    setStatus(statusorders);
    setNotes(notesorders);
  }, [orders]);

  async function changeContainer(ID) {
    const headers = { ContentType: `application/json` };
    const response = await fetch(
      `https://trust-cargo.co/anas_backend/api/filter_order_details/${ID}`,
      {
        headers,
      }
    );
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setOrders(data["order_details"]);
  }
  async function changeCustomer(ID) {
    const headers = { ContentType: `application/json` };
    const response = await fetch(
      `https://trust-cargo.co/anas_backend/api/filter_order_details_customer_id/${ID}`,
      {
        headers,
      }
    );
    const data = await response.json();
    // eslint-disable-next-line dot-notation
    setOrders(data["order_details"]);
  }
  const handleChange = (event) => {
    changeContainer(event.target.value);
  };
  const handleChangeCustomer = (event) => {
    changeCustomer(event.target.value);
  };

  const filteredRows = filterRows(orders, query);
  const pager = usePagination(filteredRows);
  return (
    <DashboardLayout>
      {/*  */}
      <SuiBox py={3}>
        <Card>
          <SuiBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
            <SuiTypography variant="h6">Items</SuiTypography>
          </SuiBox>
          <div className="row" style={{ width: "600px", margin: "20px", color: "green" }}>
            <div className="form-group col-md-4">
              <ConfirmOrder
                order_id1={orderid}
                order_code1={ordercode}
                our_item1={itemarray}
                ItemArray={itemarray}
                photo={photo}
                desc1={description1}
                desc2={description2}
                category={category}
                ctn={ctn}
                qtytoctn={qtytoctn}
                totoqty={ttoqty}
                utoprice={utoprice}
                amount={amount}
                cbm={cbm}
                ttocbm={ttocbm}
                nw={nw}
                gw={gw}
                status={status}
                notes={notes}
              />
            </div>
            <div className="form-group col-md-4">
              <ExportData excelData={orders} />
            </div>
          </div>

          <div className="row" style={{ margin: "10px" }}>
            <div className="form-group  col-md-2">
              <label
                className="control-label"
                htmlFor="name"
                style={{ fontSize: "15px", marginTop: "20px" }}
              >
                Filter Containers
              </label>
              <select
                id="shop"
                className="form-control"
                style={{ height: "40px" }}
                onChange={handleChange}
              >
                {containers.map((user) => (
                  <option value={user.id}>{user.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group  col-md-2">
              <label
                className="control-label"
                htmlFor="name"
                style={{ fontSize: "15px", marginTop: "20px", color: "black" }}
              >
                Filter Customers
              </label>
              <select
                id="shop"
                className="form-control"
                style={{ height: "40px" }}
                onChange={handleChangeCustomer}
              >
                {customers.map((user) => (
                  <option value={user.code}>{user.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Total CTN
                </label>
                <input
                  required
                  id="shop_no2"
                  type="text"
                  className="form-control"
                  name="name"
                  readOnly
                  placeholder="Total CTN"
                  // onChange={(e) => setShopNumber2(e.target.value)}
                  value={total_ctn}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Total G.w
                </label>
                <input
                  required
                  id="shop_no2"
                  type="text"
                  className="form-control"
                  name="name"
                  readOnly
                  // onChange={(e) => setShopNumber2(e.target.value)}
                  value={total_gw}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label
                  className="control-label"
                  htmlFor="name"
                  style={{ fontSize: "15px", marginTop: "20px" }}
                >
                  Total T_CBM
                </label>
                <input
                  required
                  id="shop_no2"
                  type="text"
                  className="form-control"
                  name="name"
                  readOnly
                  // onChange={(e) => setShopNumber2(e.target.value)}
                  value={total_t_cbm}
                />
              </div>
            </div>
          </div>
          <FilterBar
            value={query}
            onChange={setQuery}
            count={filteredRows.length}
            total={orders.length}
          />
          {loading ? (
            <div
              style={{
                width: "1000",
                height: "50px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CargoLoader />
            </div>
          ) : (
            <SuiBox
              sx={{
                "& .MuiTableRow-root:not(:last-child)": {
                  "& td": {
                    borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                      `${borderWidth[1]} solid ${borderColor}`,
                  },
                },
              }}
            >
              <>
                <Table sx={{ overflow: "scroll", display: "block" }} aria-label="simple table">
                  <TableHead>
                    <TableRow style={{ display: "flex" }}>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Order Code
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Container ID
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Customer Code
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Our Item
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Item Number
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Status
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Photo
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Desc English
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          CTN
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          QTY/CTN
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          T/QTY
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          CBM
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          T/CBM
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          N.W
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          G.W
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Status
                        </TableCell>
                      </Box>
                      <Box>
                        <TableCell sx={{ width: "180px", minWidth: "180px" }} align="center">
                          Notes
                        </TableCell>
                      </Box>
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ display: "block " }}>
                    {pager.pageRows.map((vla, index) => (
                      <TableRow key={`${index}key`} sx={{ minWidth: "100px" }}>
                        <Box style={{ overflowX: "auto" }}>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              id="item"
                              required
                              onChange={(e) => handleOrderCodeChange(e, index)}
                              value={ordercode[index]}
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="Order Code"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              id="item"
                              required
                              onChange={(e) => handleContainerIDChange(e, index)}
                              value={container_id[index]}
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="Container ID"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              id="item"
                              required
                              onChange={(e) => handleCustomerIDChange(e, index)}
                              value={customer_id[index]}
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              id="item"
                              required
                              onChange={(e) => handleItemChange(e, index)}
                              value={itemarray[index]}
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="Our Item"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              id="item"
                              required
                              onChange={(e) => handleItemChange(e, index)}
                              value={itemarray[index]}
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="Item Number"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              id="item"
                              required
                              onChange={(e) => handleProductStautsChange(e, index)}
                              value={statusProducts[index]}
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="Status"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <img
                              src={photo[index]}
                              style={{ width: "100px", height: "60px" }}
                              alt=""
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              id="desc2"
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="Desc English"
                              onChange={(e) => handleDesc2Change(e, index)}
                              value={description2[index]}
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="CTN"
                              onChange={(e) => handleCTNChange(e, index)}
                              value={ctn[index]}
                              id="ctn"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="QTY/CTN"
                              onChange={(e) => handleQTYTOCTNChange(e, index)}
                              value={qtytoctn[index]}
                              id="qtytoctn"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              readOnly
                              placeholder="T/QTY"
                              // onChange={(e) => handleTTOQTYChange(e, index)}
                              value={ttoqty[index]}
                              id="ttoqty"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="CBM"
                              onChange={(e) => handleCBMChange(e, index)}
                              value={cbm[index]}
                              id="cbm"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="T/CBM"
                              readOnly
                              // onChange={(e) => handleTTOCBMChange(e, index)}
                              value={ttocbm[index]}
                              id="ttocbm"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="N.W"
                              onChange={(e) => handleNWChange(e, index)}
                              value={nw[index]}
                              id="nw"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="G.W"
                              readOnly
                              // onChange={(e) => handleGWChange(e, index)}
                              value={gw[index]}
                              id="gw"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="Status"
                              onChange={(e) => handleStatusChange(e, index)}
                              value={status[index]}
                              id="status"
                            />
                          </TableCell>
                          <TableCell sx={{ width: "150px", minWidth: "150px" }} align="start">
                            <input
                              required
                              type="text"
                              style={{ width: "150px", minWidth: "150px" }}
                              className="form-control"
                              name="name"
                              placeholder="Notes"
                              onChange={(e) => handleNotesChange(e, index)}
                              value={notes[index]}
                              id="notes"
                            />
                          </TableCell>
                        </Box>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Pagination {...pager} />
              </>
            </SuiBox>
          )}
        </Card>
      </SuiBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default AllOrders;
